import APIService from './APIService';

export default {
  getAllToursPaginas() {
    return APIService.apiCall().get(`/tour/getAllToursPaginas`);
  },
  getRelacaoTourUser() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('/tour/getRelacaoTourUser')
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => reject(error));
    });
  },
  desativarTourUserCurrentPage(nomePagina) {
    return APIService.apiCall().post(`/tour/desativarTour/${nomePagina}`);
  }
};
